/*
    Component logic
    This component displays all the interaction stages that are possible.
    It then shows if there any interactions that have been executed against  aparticular contact.
    This is known by a checkbox against the interaction stage. If checked, it means something was done earlier.

    Finally, the rep can update and add execute new interaction stages.
    
*/

import  {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
//import {useToken, useTerritory, useTenancy} from './useToken';
import useToken, { useTerritory, useTenancy, useUser} from './useToken';


export default function Interaction(){
    let params = useParams();
    const contact_id = params.id;
    const[contactId, setContactId] = useState();
    const token = useToken();
    const user = useUser();
    const territory = useTerritory();
    const tenancy = useTenancy();
    
    //const territory = "2"
    //const tenancy = "1"

   
    useEffect(()=>{
        setContactId(()=>contact_id);
        console.log(contactId);
    }, []);

    

    const[flowDefn, setFlowDefn] = useState([]);
    const[interactions, setInteractions] = useState([]);

  

    function  handleFormSubmit(event){

        const flowId = document.activeElement.id;
        event.preventDefault();
        
        // Check if this a new interaction to be created or an earlier one to be updated

        const interactionId = event.target.elements[`interactionId${flowId}`].value;
        const flow_phase_id = event.target.elements[`flowPhaseId${flowId}`].value;
        const flow_phase_status =  event.target.elements[`status${flowId}`].value=="on"?"true":"false"; 
        const contact_notes = event.target.elements[`contactNotes${flowId}`].value
        
        if (interactionId==0){
            // Create new Interaction
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization' :`Token ${token}` },
                body:JSON.stringify({ flow_phase_id:flow_phase_id, flow_phase_status: flow_phase_status,prospect:contactId, contact_notes:contact_notes, user:user, territory:territory, tenancy:tenancy })
            };
            const URL4CreateInteraction = process.env.NODE_ENV === 'development'?process.env.REACT_APP_API_URL_DEV_MODE + 'api/contact-interactions/create/': process.env.REACT_APP_API_URL_PROD_MODE + 'api/contact-interactions/create/';

            fetch(URL4CreateInteraction, requestOptions)
            .then(response => response.json())
            .then(data => console.log("Created Success!"));
        }
        else{
            // Update the interaction
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization' :`Token ${token}` },
                body:JSON.stringify({flow_phase_status: flow_phase_status, contact_notes:contact_notes, user:user, territory:territory, tenancy:tenancy })
            };
            
            const UpdateInteractionURL = process.env.NODE_ENV === 'development' ? `${process.env.REACT_APP_API_URL_DEV_MODE}api/contact-interactions/update/${interactionId}/`: `${process.env.REACT_APP_API_URL_PROD_MODE}api/contact-interactions/update/${interactionId}/`;
            
            fetch(UpdateInteractionURL, requestOptions)
            .then(response => response.json())
            .then(data => console.log("Created Success!"));

        }
            

       
    }
  

    function getContactInteraction(flowPhaseId, flowPhaseName){
        let interactionJSX=<></>
        let blnInteractionPresent = false;
        
        interactions.map(interactionObj=>
        {
            
            
            
            if(interactionObj.flow_phase_id==flowPhaseId){
               
                console.log("Compared true");
                blnInteractionPresent=true;
                interactionJSX =  
                        <>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 text-center">
                                <input type="hidden" name={`interactionId${flowPhaseId}`}  id={`interactionId${flowPhaseId}`} defaultValue={interactionObj.id} />
                                <input type="hidden" name={`flowPhaseId${flowPhaseId}`}  id={`flowPhaseId${flowPhaseId}`} defaultValue={flowPhaseId} />
                                <input id = {`status${flowPhaseId}`} name = {`status${flowPhaseId}`}  type="checkbox" defaultChecked="true" />
                            </td>
                            <td className="text-sm text-gray-900 font-semibold px-6 py-4 whitespace-nowrap">{flowPhaseName}</td>
                            <td className="text-sm text-gray-900 font-semibold  px-6 py-4 whitespace-nowrap">
                                <textarea className = "txtarea" id = {`contactNotes${flowPhaseId}`} name = {`contactNotes${flowPhaseId}`}  defaultValue={interactionObj.contact_notes}></textarea>
                            </td>
                            <td className="text-sm text-gray-900 font-semibold  px-6 py-4 whitespace-nowrap text-center">
                                <input type="submit" className="btn" id = {flowPhaseId} value="Update Status"  />
                            </td>
                        </>
                   

            }

         
        })
        
        if (blnInteractionPresent==true)
            return interactionJSX;
        else {
            // This means there has been no interaction for this stage.
            // Set hidden textbox interactionId${flowPhaseId} value to 0. This is an indicator of 0 interactions.
            return (
                <>
                    
                    <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap text-center">
                        <input type="hidden" name={`interactionId${flowPhaseId}`}  id={`interactionId${flowPhaseId}`} defaultValue="0" />
                        <input type="hidden" name={`flowPhaseId${flowPhaseId}`}  id={`flowPhaseId${flowPhaseId}`} defaultValue={flowPhaseId} />

                        <input id = {`status${flowPhaseId}`} name = {`status${flowPhaseId}`}  type="checkbox" defaultChecked="" />
                    </td>
                    <td className="text-sm text-gray-900 font-semibold  px-6 py-4 whitespace-nowrap">{flowPhaseName}</td>
                    <td className="text-sm text-gray-900 font-semibold  px-6 py-4 whitespace-nowrap">
                        <textarea className="txtarea" type="text" id = {`contactNotes${flowPhaseId}`} name = {`contactNotes${flowPhaseId}`}  defaultValue=""></textarea>
                    </td>
                    <td className="text-sm text-gray-900 font-semibold  px-6 py-4 whitespace-nowrap text-center">
                        <input type="submit" className="btn" id = {flowPhaseId} value="Update Status"/>
                    </td>
                </>
            );
        }
       
    }

    useEffect(()=>{
        const URLForContactInteractions =process.env.NODE_ENV === 'development' ? `${process.env.REACT_APP_API_URL_DEV_MODE}api/contact-interactions/${contact_id}/`: `${process.env.REACT_APP_API_URL_PROD_MODE}api/contact-interactions/${contact_id}/`;
        fetch(URLForContactInteractions, {headers: {"Authorization" :  `Token ${token}`}})
        .then((res) => res.json())
        .then((data)=>{
            setInteractions((oldData)=>[...interactions, ...data]);
            
            
            const URLForFlowDefn = process.env.NODE_ENV === 'development'?process.env.REACT_APP_API_URL_DEV_MODE + 'api/flow_defn/': process.env.REACT_APP_API_URL_PROD_MODE + 'api/flow_defn/';
            fetch(URLForFlowDefn, {headers: {"Authorization" :  `Token ${token}`}})
            .then((res)=>res.json())
            .then ((data)=> {
                setFlowDefn((oldData)=>[...flowDefn, ...data]);
              

            })

        })
        .catch(error=> console.log(error))

    }, []);


    // Now return Interactions JSX
    return(
            <form onSubmit={handleFormSubmit}>
                <div class="flex flex-col align-middle justify-center w-2/3  mt-5 mx-10">
                    
                                <table class="px-6 border-collapse  border border-slate-400">
                                    <thead class="bg-yellow-300 font-bold text-lg border-b ">
                                        <tr>
                                            <th scope="col" class="text-sm font-semibold text-gray-900 px-6 py-4 text-center">
                                                Interaction Status
                                            </th>
                                            <th scope="col" class="text-sm font-semibold text-gray-900 px-6 py-4 text-left">
                                                Interaction Stage Name
                                            </th>
                                            <th scope="col" class="text-sm font-semibold text-gray-900 px-6 py-4 text-left">
                                                Interaction Stage Notes
                                            </th>
                                            <th scope="col" class="text-sm font-semibold text-gray-900 px-6 py-4 text-center">
                                                Interaction Stage Update
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {flowDefn.map(flowDefnObj=>(
                                                <tr class="bg-slate-100  border-b transition duration-300 ease-in-out hover:bg-gray-200 ">
                                                    {getContactInteraction(flowDefnObj.id, flowDefnObj.flow_phase_name)}
                                                </tr>
                                            ))
                                        }

                                    </tbody>
                                </table>

                </div>
                                        



            


            </form>
    );
   

}